import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextPreviewComponent } from './text-preview/text-preview.component';
import { AVAILABLE_PREVIEWS, DefaultPreviews } from './available-previews';
import { PreviewContainerComponent } from './preview-container/preview-container.component';
import { PortalModule } from '@angular/cdk/portal';
import { VideoPreviewComponent } from './video-preview/video-preview.component';
import { ImagePreviewComponent } from './image-preview/image-preview.component';
import { PdfPreviewComponent } from './pdf-preview/pdf-preview.component';
import { DefaultPreviewComponent } from './default-preview/default-preview.component';
import { MatButtonModule } from '@angular/material/button';
import { AudioPreviewComponent } from './audio-preview/audio-preview.component';
import { GoogleDocsViewerComponent } from './google-docs-viewer/google-docs-viewer.component';
import { UiModule } from '../core/ui/ui.module';
import { FirefilePreviewComponent } from './firefile-preview/firefile-preview.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { ClipboardModule } from 'ngx-clipboard';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShareButtonsModule } from '@ngx-share/buttons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxSpinnerModule } from "ngx-spinner";
import './icons';
import { AdsenseDesktop } from './adsense.component';
import { AdsenseResponsive } from './adsense-responsive.component';
import { AdBanner } from './adbanner.component';
import { AdCash } from './adcash.component';
import { Mopinion } from './mopinion.component';
import { AdCashPopunder } from './adcash-popunder.component';
import { AdCashPush } from './adcash-push.component';
import { Angulartics2Module } from 'angulartics2';

@NgModule({
    imports: [
        CommonModule,
        UiModule,

        // material
        PortalModule,
        MatButtonModule,
        NgxCaptchaModule,
        ClipboardModule,
        MatTooltipModule,
        ReactiveFormsModule,
        ShareButtonsModule,
        NgxSpinnerModule,
        Angulartics2Module
    ],
    exports: [
        PreviewContainerComponent,
    ],
    declarations: [
        PreviewContainerComponent,
        TextPreviewComponent,
        VideoPreviewComponent,
        ImagePreviewComponent,
        PdfPreviewComponent,
        DefaultPreviewComponent,
        AudioPreviewComponent,
        GoogleDocsViewerComponent,
        FirefilePreviewComponent,
        AdsenseDesktop,
        AdsenseResponsive,
        AdBanner,
        AdCash,
        Mopinion,
        AdCashPopunder,
        AdCashPush
    ],
    entryComponents: [
        TextPreviewComponent,
        VideoPreviewComponent,
        ImagePreviewComponent,
        PdfPreviewComponent,
        DefaultPreviewComponent,
        AudioPreviewComponent,
        GoogleDocsViewerComponent,
        FirefilePreviewComponent
    ],
    providers: [
        {provide: AVAILABLE_PREVIEWS, useClass: DefaultPreviews},
    ]
})
export class FilePreviewModule {
}
